;
define("product_views_option_integer.tpl", function(){});

